// extracted by mini-css-extract-plugin
export default {"limitSelectorContainer":"style_limitSelectorContainer__4jvkY","root":"style_root__bJGPw"};